import React, { FC, useEffect } from 'react'
import { ATTENDANCE_NOTICE_FLAG, CurrentUserType } from 'src/ducks/auth'
import { LobbyEntry } from '../../components/LobbyEntry'
import PageWithBg from '../../components/PageWithBg'
import Amplitude from '../../utils/amplitudeHelper'
import { StyledLobby } from './styled'
import { desktopAssets, fixedAssets } from 'src/containers/PreCache'
import styled from 'styled-components'
import { GlobalModalTypes } from 'src/components/GlobalModals/modalTypes'
import { useDispatch } from 'react-redux'
import { showGlobalModal } from 'src/ducks/layout'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router'
import config from 'src/config'
import NoticeBar from 'src/components/NoticeBar'


export const LobbyPage: FC<{ currentUser: CurrentUserType }> = ({ currentUser }) => {
  const dispatch = useDispatch()
  let { search } = useLocation()
  const query = new URLSearchParams(search)
  const toastMsg = query.get('message')

  useEffect(() => {
    // Guard: window.chaport is undefined while the widget script is disabled
    // (see public/index.html / config.ENABLE_CHAPORT) — calling .q on it
    // unconditionally throws on every Lobby mount.
    if (window.chaport) {
      window.chaport.q('hideLauncher')
    }
    document.title = `${config.eventName} | Lobby`
  }, [])

  useEffect(() => {
    Amplitude.visit('Lobby')
  }, [currentUser.id])

  useEffect(() => {
    toast(toastMsg, { toastId: 'auditoriumClosed' })
  }, [toastMsg])

  // Attendance reminder — fires once per login, on the first Lobby landing.
  useEffect(() => {
    if (sessionStorage.getItem(ATTENDANCE_NOTICE_FLAG)) {
      sessionStorage.removeItem(ATTENDANCE_NOTICE_FLAG)
      dispatch(showGlobalModal(GlobalModalTypes.AttendanceNotice))
    }
  }, [dispatch])

  return (
    <>
      
      <StyledLobby>
        <PageWithBg bgImg={desktopAssets.lobbyBg}>
          <>
            <div className="iframe">
              <VideoPlaceholder url={config.LOBBY_VIDEO} />
            </div>
            {config.lobbyEntries.map((entry) => {
              return <LobbyEntry key={entry.id} {...entry} currentUser={currentUser} />
            })}

            {/* <div id="helpdesk">
            <img src={fixedAssets.helpdeskStand} width="100%" alt="Helpdesk Stand" />
            </div>
            <div id="profile">
            <img src={fixedAssets.speakersStand} width="100%" alt="Speakers Profile Stand" />
            </div> */}
          </>
          {/* <Guide onClick={openGuideModalHandler}>
              <svg width="482" height="49" viewBox="0 0 482 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M465.94 47H-20V2H480V32.3007L465.94 47Z" fill="url(#paint0_linear_1_42)" stroke="white" stroke-width="3" stroke-miterlimit="10"/>
                <defs>
                  <linearGradient id="paint0_linear_1_42" x1="230" y1="47" x2="230" y2="2" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#EE4036"/>
                    <stop offset="0.2" stop-color="#C73A4F"/>
                    <stop offset="0.45" stop-color="#9C346B"/>
                    <stop offset="0.67" stop-color="#7E307F"/>
                    <stop offset="0.87" stop-color="#6B2D8B"/>
                    <stop offset="1" stop-color="#652D90"/>
                  </linearGradient>
                </defs>
              </svg>
              <p>Click Here to Navigate the Virtual Platform</p>
            </Guide> */}
        </PageWithBg>
      </StyledLobby>
    </>
  )
}

const VideoPlaceholder = ({ url }: { url: string }) => {
  if (url) {
    return <iframe title="Lobby Video" src={url} allowFullScreen frameBorder="0" allow="autoplay;encrypted-media" />
  }

  return (
    <div
      style={{
        background: '#000',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img src={fixedAssets.playBtn} alt="Play Button" style={{ width: '100%', maxWidth: '132px' }} />
    </div>
  )
}
export const Guide = styled.div`
  position: fixed;
  bottom: 25px;
  left: 0;
  cursor: pointer;

  p {
    position: absolute;
    top: 0;
    width: 100%;
    color: white;
    font-size: 20px;
    text-align: center;
    margin: 0;
    height: 100%;
    margin-top: 8px;
  }
`
